import React, { useState } from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import AttributePanel from './AttributePanel';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import FeatureSummary from '../../../../Util/FeatureSummary';

const AttributesTable = ({
  attributes,
  cobrandList,
  loading,
  refreshAttributes,
  setShowToast,
}) => {
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [attributeToDelete, setAttributeToDelete] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const columns = [
    {
      minWidth: 30,
      maxWidth: 30,
      onRender: (item) => (
        <ContextualMenu
          editOnClick={() => handleEdit(item)}
          deleteOnClick={() => handleDeleteClick(item)}
          item={item}
        />
      ),
    },
    {
      name: 'ID',
      fieldName: 'attributeId',
      minWidth: 50,
      maxWidth: 70,
      isResizable: true,
    },
    {
      name: 'Attribute Name',
      fieldName: 'attributeName',
      minWidth: 150,
      maxWidth: 250,
      isResizable: true,
      onRender: (item) => (
        <span>
          {item.attributeName}
          {!item.isMatch && <span style={{ color: 'red', marginLeft: 5 }}>*</span>}
        </span>
      ),
    },
    {
      name: 'Group Name',
      fieldName: 'attributeGroupName',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      name: 'Cobrand Value',
      fieldName: 'attributeValue',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      name: 'Global Value',
      fieldName: 'globalAttributeValue',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      name: 'Format Type',
      fieldName: 'valueFormatType',
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
    {
      name: 'Attribute Type',
      fieldName: 'attributeTypeName',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      name: 'Focus Type',
      fieldName: 'focusTypeName',
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
  ];

  const items = attributes ?? [];

  const handleAdd = () => {
    setSelectedAttribute(null);
    setIsEditMode(false);
    setIsPanelOpen(true);
  };

  const handleEdit = (item) => {
    setSelectedAttribute(item);
    setIsEditMode(true);
    setIsPanelOpen(true);
  };

  const handleDeleteClick = (item) => {
    setAttributeToDelete(item);
    setIsDeleteModalOpen(true);
  };

  const handleSaveSuccess = () => {
    setIsPanelOpen(false);
    setShowToast(true);
    refreshAttributes();
  };

  const handleDeleteSuccess = () => {
    setIsDeleteModalOpen(false);
    setShowToast(true);
    refreshAttributes();
  };

  return (
    <>
      <DetailsTable
        items={items}
        columns={columns}
        loading={loading}
        mainColumn={'attributeName'}
        style={{
          position: 'relative',
          height: '75vh',
          width: '100%',
        }}
        CommandBar={
          <>
            <CommandBarButton
              iconProps={{ iconName: 'Add' }}
              text="Add Attribute"
              onClick={handleAdd}
            />
          </>
        }
      />

      <FeatureSummary
        label="About Attributes"
        summary="This table displays all cobrand attribute settings, including attribute name, group, values, and types. You can add, edit, or delete attributes. The Attribute Cobrand Settings feature allows admins to manage custom attributes for cobrands, supporting advanced configuration and reporting."
      />

      <AttributePanel
        isOpen={isPanelOpen}
        onDismiss={() => setIsPanelOpen(false)}
        attribute={selectedAttribute}
        cobrandList={cobrandList}
        isEditMode={isEditMode}
        onSaveSuccess={handleSaveSuccess}
      />

      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onDismiss={() => setIsDeleteModalOpen(false)}
        attribute={attributeToDelete}
        cobrandList={cobrandList}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </>
  );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, item }) => {
  const menuProps = {
    items: [
      {
        key: 'edit',
        iconProps: { iconName: 'Edit' },
        text: 'Edit',
        onClick: () => editOnClick(item),
      },
      {
        key: 'delete',
        iconProps: { iconName: 'Delete' },
        text: 'Delete',
        onClick: () => deleteOnClick(item),
      },
    ],
  };

  return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} />;
};

export default AttributesTable;
